<!--Pick Settings to Edit-->
<div class="OptionDiv">
	<h4>Settings For:</h4>
	<div class="RadioFlex">
		<input class="RadioBtn" type="radio" [(ngModel)]="SettingsOption" name="SettingsOption" id="SetDistrict" value="District" />
		<label class="LargeRight" for="SetDistrict">District Defaults</label>

		<input class="RadioBtn" type="radio" [(ngModel)]="SettingsOption" name="SettingsOption" id="SetFacility" value="Facility" />
		<label class="LargeRight" for="SetFacility">Facility</label>

		<input class="RadioBtn" type="radio" [(ngModel)]="SettingsOption" name="SettingsOption" id="SetStation" value="Station" />
		<label for="SetStation">Station</label>
	</div>
</div>

<!--Settings-->
<div class="TopMargin">
	<div *ngIf="SettingsOption == 'District'">
		<!-- <caass-ms-district-settings> </caass-ms-district-settings> -->
		<caass-multistation-district-settings></caass-multistation-district-settings>
	</div>
	<div *ngIf="SettingsOption == 'Facility'">
		<!-- <caass-ms-facility-settings> </caass-ms-facility-settings> -->
		<caass-multistation-facility-settings></caass-multistation-facility-settings>
	</div>
	<div *ngIf="SettingsOption == 'Station'">
		<!-- <caass-ms-station-settings> </caass-ms-station-settings> -->
		<caass-multistation-station-settings> </caass-multistation-station-settings>
	</div>
</div>
